
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 4.667C2 4.298 2.298 4 2.667 4h10.666a.667.667 0 110 1.333H2.667A.667.667 0 012 4.667zM2 8c0-.368.298-.667.667-.667h10.666a.667.667 0 110 1.334H2.667A.667.667 0 012 8zm.667 2.667a.667.667 0 100 1.333h10.666a.667.667 0 000-1.333H2.667z","fill":"#282E3E"}})])
          )
        }
      }
    